<template>
    <div style="margin-top: 30px">
        <div @click="toR('/profile/password')" class="left-sub-tab"
             :class="{active: $route.path === '/profile/password'}">Сменить пароль</div>

        <div @click="toR('/profile/help')" class="left-sub-tab"
             :class="{active: $route.path === '/profile/help'}">Инструкция</div>

        <div @click="toR('/profile/about')" class="left-sub-tab"
             :class="{active: $route.path === '/profile/about'}">О системе</div>
    </div>
</template>

<script>
    import { mapActions} from 'vuex'

    export default {
        data(){
            return {

            }
        },
        methods:{
            toR(path){
                this.$router.push(path);
                this.hideLeftMenu();
            },
            ...mapActions([
                'hideLeftMenu',
            ]),
        }
    }
</script>
